import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import './index.css';
import App from './App';
import TabBadge from './components/TabBadge';
import store from './redux/store';
import theme from './theme';
import reportWebVitals from './reportWebVitals';

if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations()
        .then((regs) => {
            if (!regs.length) return null;
            return Promise.all(regs.map((r) => r.unregister()))
                .then(() => (window.caches ? caches.keys().then((keys) => Promise.all(keys.map((k) => caches.delete(k)))) : null))
                .then(() => {
                    if (!sessionStorage.getItem('sw-cleared')) {
                        sessionStorage.setItem('sw-cleared', '1');
                        window.location.reload();
                    }
                });
        })
        .catch(() => { });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <TabBadge />
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
